export default "__VITE_ASSET__7695eb9b__"